import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unreachable',
  templateUrl: './unreachable.component.html',
  styleUrls: ['./unreachable.component.css']
})
export class UnreachableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
